










































































































































































































import { Component, Vue } from 'vue-property-decorator'
import Pagination from '@/components/Pagination/index.vue'
import { familyLabelFor } from '@/models/sorewardsProgramTypes'
import { listAllLoadTransactions, listLoadTransactions } from '@/services/sorewards/console'
import { downloadCsv } from '@/services/sorewards/csv'
import { LoadRow, LoadStats } from '@/services/sorewards/types'
import SorewardsCaretakerSelect from '@/views/sorewards/components/caretaker-select.vue'
import SorewardsCostCell from '@/views/sorewards/components/cost-cell.vue'
import SorewardsCoverageBar from '@/views/sorewards/components/coverage-bar.vue'

@Component({
  name: 'SorewardsLoadTransactions',
  components: {
    Pagination,
    SorewardsCaretakerSelect,
    SorewardsCostCell,
    SorewardsCoverageBar
  }
})
export default class extends Vue {
  private listLoading = true
  private exporting = false
  private list: LoadRow[] = []
  private dateRange: [string, string] | null = null
  private listQuery = {
    page: 1,
    per: 20,
    caretakerId: '',
    caretakerName: '',
    idDistribution: '',
    dotationOrder: '',
    beneficiary: '',
    cardId: ''
  }

  private stats: LoadStats = {
    totalLoaded: 0,
    totalRemaining: 0,
    totalLoadCost: 0,
    cardsCount: 0,
    filteredCount: 0,
    totalCount: 0
  }

  created() {
    this.getList()
  }

  private filters() {
    return {
      page: this.listQuery.page,
      per: this.listQuery.per,
      caretakerId: this.listQuery.caretakerId || undefined,
      caretakerName: this.listQuery.caretakerName || undefined,
      dateFrom: this.dateRange ? this.dateRange[0] : undefined,
      dateTo: this.dateRange ? this.dateRange[1] : undefined,
      idDistribution: this.listQuery.idDistribution || undefined,
      dotationOrder: this.listQuery.dotationOrder || undefined,
      beneficiary: this.listQuery.beneficiary || undefined,
      cardId: this.listQuery.cardId || undefined
    }
  }

  private async getList() {
    this.listLoading = true
    try {
      const result = await listLoadTransactions(this.filters())
      this.list = result.data
      this.stats = result.stats
    } finally {
      this.listLoading = false
    }
  }

  private handleFilter() {
    this.listQuery.page = 1
    this.getList()
  }

  private resetFilters() {
    this.dateRange = null
    this.listQuery = {
      page: 1,
      per: this.listQuery.per,
      caretakerId: '',
      caretakerName: '',
      idDistribution: '',
      dotationOrder: '',
      beneficiary: '',
      cardId: ''
    }
    this.getList()
  }

  private async exportCsv() {
    this.exporting = true
    try {
      const filters = this.filters()
      const rows = await listAllLoadTransactions({
        caretakerId: filters.caretakerId,
        caretakerName: filters.caretakerName,
        dateFrom: filters.dateFrom,
        dateTo: filters.dateTo,
        idDistribution: filters.idDistribution,
        dotationOrder: filters.dotationOrder,
        beneficiary: filters.beneficiary,
        cardId: filters.cardId
      })
      downloadCsv(
        this.$i18n.locale === 'en' ? 'load-transactions.csv' : 'chargements.csv',
        [
          String(this.$t('sorewardsConsole.idDistribution')),
          String(this.$t('sorewardsConsole.caretaker')),
          String(this.$t('sorewardsConsole.operation')),
          String(this.$t('sorewardsConsole.dotationOrder')),
          String(this.$t('sorewardsConsole.program')),
          String(this.$t('sorewardsConsole.dotationType')),
          String(this.$t('sorewardsConsole.dotationDate')),
          String(this.$t('sorewardsConsole.loadDate')),
          String(this.$t('sorewardsConsole.loadRef')),
          String(this.$t('sorewardsConsole.expiry')),
          String(this.$t('sorewardsConsole.amount')),
          String(this.$t('sorewardsConsole.beneficiary')),
          String(this.$t('sorewardsConsole.cardId')),
          String(this.$t('sorewardsConsole.remaining')),
          String(this.$t('sorewardsConsole.loadCost')),
          String(this.$t('sorewardsConsole.coverLoad')),
          String(this.$t('sorewardsConsole.caretakerShare'))
        ],
        rows.map(row => [
          row.idDistribution,
          row.caretakerName,
          this.operationLabel(row.programFamily),
          row.dotationOrder,
          this.familyLabel(row.programFamily),
          row.dotationType,
          row.dotationDate,
          row.loadDate,
          row.loadRef,
          row.expiry,
          row.amount,
          row.beneficiary,
          row.cardId,
          row.remaining,
          row.cost.value,
          `${row.coverage}%`,
          row.cost.caretakerShare
        ])
      )
    } finally {
      this.exporting = false
    }
  }

  private familyLabel(family: string) {
    return familyLabelFor(
      family,
      (key: string) => String(this.$t(key)),
      (key: string) => this.$te(key)
    )
  }

  private operationLabel(family: string) {
    const key = `sorewardsConsole.operations.${family}`
    return this.$te(key) ? String(this.$t(key)) : this.familyLabel(family)
  }
}
